import { useEffect, useRef } from "react"

const decimalCommaToDotString = (value) => {
  if (!value) return ""
  return String(value).replace(",", ".")
}

export const useEmitIdOrdinariosEffect = (formData, setFormData) => {
  const prevValuesRef = useRef(null)

  useEffect(() => {
    if (!formData?.caracteristicas || !formData?.datas) return

    const { caracteristicas, datas } = formData

    const gerarIdEmissao = () =>
      (
        `${caracteristicas.tipoAtivo || ""}_` +
        `${caracteristicas.cpfCnpjDevedor || caracteristicas.devedor || ""}_` +
        `${datas.dataEmissao || ""}_` +
        `${datas.dataVencimento || ""}_` +
        `${caracteristicas.indexador || ""}_` +
        `${decimalCommaToDotString(caracteristicas.taxaJuros) || ""}`
      ).toUpperCase()

    const camposDependentes = {
      tipoAtivo: caracteristicas.tipoAtivo,
      devedor: caracteristicas.cpfCnpjDevedor || caracteristicas.devedor,
      dataEmissao: datas.dataEmissao,
      dataVencimento: datas.dataVencimento,
      indexador: caracteristicas.indexador,
      taxa: caracteristicas.taxaJuros
    }

    // primeira execução: só guarda valores (não sobrescreve ID vindo do backend)
    if (prevValuesRef.current === null) {
      prevValuesRef.current = camposDependentes
      return
    }

    const mudouCampoBase = Object.keys(camposDependentes).some(
      key => prevValuesRef.current[key] !== camposDependentes[key]
    )

    prevValuesRef.current = camposDependentes

    if (!mudouCampoBase) return

    const novoId = gerarIdEmissao()

    setFormData(prev => ({
      ...prev,
      caracteristicas: {
        ...prev.caracteristicas,
        emissao: novoId
      }
    }))
  }, [
  formData?.caracteristicas?.tipoAtivo,
  formData?.caracteristicas?.devedor,
  formData?.caracteristicas?.cpfCnpjDevedor,
  formData?.caracteristicas?.indexador,
  formData?.caracteristicas?.taxaJuros,
  formData?.datas?.dataEmissao,
  formData?.datas?.dataVencimento,
  setFormData
])
}